import { NavLink, useLocation } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { getPageTitle } from "../../utils/dynamicPageHeader";

const jobTabs = [
  ["All jobs", "all"], ["Initiated", "initiated"], ["Assigned", "assigned"],
  ["In progress", "in-progress"], ["Completed", "completed"],
  ["Cancelled", "cancelled"], ["Deleted", "deleted"], ["History", "history"],
];

export default function WorkspaceHeading() {
  const { pathname } = useLocation();
  const isJobList = jobTabs.some(([, path]) => pathname === "/jobs/" + path);
  const isTrips = ["/trips/active", "/trips/history"].includes(pathname);
  const isFleet = ["/fleet/drivers", "/fleet/trucks"].includes(pathname);
  const tabs = isJobList ? jobTabs.map(([label, path]) => [label, "/jobs/" + path])
    : isTrips ? [["Active trips", "/trips/active"], ["Trip history", "/trips/history"]]
    : isFleet ? [["Trucks & trailers", "/fleet/trucks"], ["Drivers", "/fleet/drivers"]] : [];
  const title = isJobList ? "Jobs" : isTrips ? "Trips" : isFleet ? "Fleet & drivers" : getPageTitle(pathname) || "Workspace";
  const description = isJobList ? "Plan, assign and manage every container move."
    : isTrips ? "Follow your trips and keep every move on track."
    : isFleet ? "Your people and vehicles, ready for the next move."
    : pathname === "/dashboard" ? "An overview of your transport operations."
    : "Manage your transport operations in one place.";
  return (
    <section className="workspace-heading" aria-label="Current workspace">
      <div className="workspace-title-row"><div><h1>{title}</h1><p>{description}</p></div><div className="workspace-breadcrumb"><Breadcrumb showTitle={false} /></div></div>
      {tabs.length > 0 && <nav className="workspace-tabs" aria-label={title + " views"}>
        {tabs.map(([label, path]) => <NavLink key={path} to={path} end>{label}</NavLink>)}
      </nav>}
    </section>
  );
}
